module.exports = __webpack_public_path__ + "media/images/emoticons/banana-4dbfb181f7449b9dbc72d994625c7c3c.gif";